export default {
    token: '',
    webData: [],
    showPath: '',
    // Local:'api/CM-API/',
    Local: 'https://xiangjunkeji.cn/CM-API/',
    compey: []
}



//////////////////
// WEBPACK FOOTER
// ./static/js/global.js
// module id = null
// module chunks = 